import React from "react";
import GoogleMapReact from 'google-map-react';
import {PinSvg} from "../../../assets";
import {useWindowSize} from "../../Home/Common/SimpleRowGridA";

const AnyReactComponent = () => (
    <div>
        <PinSvg style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
        }}/>
    </div>
);

const token = process.env.REACT_APP_GOOGLE_MAP_TOKEN || '';

export default function SimpleMap({lat, lng, zoom}) {
    const size = useWindowSize();
    const createMapOptions = (maps) => {
        return {
            fullscreenControl: false,
            zoomControl: false,
            mapId: '75d748d596497142'
        }
    }
    const mapHeight = size?.width > 1280 ? '426px' : '315px'
    return (
        <div style={{height: mapHeight, width: '100%'}}>
            <GoogleMapReact
                bootstrapURLKeys={{key: token}}
                defaultCenter={{lat: parseFloat(lat), lng: parseFloat(lng)}}
                defaultZoom={zoom}
                options={createMapOptions}
            >
                <AnyReactComponent
                    lat={lat}
                    lng={lng}
                />
            </GoogleMapReact>
        </div>
    );
}